import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
export type BulkUploadValidationFragmentFragment = { readonly __typename?: 'BulkUploadValidationResult', readonly totalSent: number, readonly totalAdditions: number, readonly totalUpdates: number, readonly totalErrors: number, readonly items: ReadonlyArray<{ readonly __typename?: 'BulkUploadItemValidationResult', readonly id: string, readonly isUpdate?: boolean | null, readonly isAddition?: boolean | null, readonly hasError?: boolean | null, readonly errorMessage?: string | null, readonly unflattenedValue?: unknown | null, readonly validationBreakdown?: unknown | null }> };

export type BulkUploadResultFragmentFragment = { readonly __typename?: 'BulkUploadResult', readonly totalSent: number, readonly totalAdditions: number, readonly totalUpdates: number, readonly totalErrors: number, readonly errors: ReadonlyArray<{ readonly __typename?: 'BulkUploadError', readonly id: string, readonly unflattenedData?: unknown | null, readonly errorMessage?: string | null }> };

export const BulkUploadValidationFragmentFragmentDoc = gql`
    fragment BulkUploadValidationFragment on BulkUploadValidationResult {
  items {
    id
    isUpdate
    isAddition
    hasError
    errorMessage
    unflattenedValue
    validationBreakdown
  }
  totalSent
  totalAdditions
  totalUpdates
  totalErrors
}
    `;
export const BulkUploadResultFragmentFragmentDoc = gql`
    fragment BulkUploadResultFragment on BulkUploadResult {
  errors {
    id
    unflattenedData
    errorMessage
  }
  totalSent
  totalAdditions
  totalUpdates
  totalErrors
}
    `;